// extracted by mini-css-extract-plugin
export default {"input-box":"input-box__GgS4K","input":"input__6JtXF"};